export default "__VITE_ASSET__BcR0jyzl__"